import type { FC } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

export const PieceMedium: FC<SvgIconProps> = (props) => (
  <SvgIcon width="24" height="24" {...props}>
    <path
      fillRule="evenodd"
      d="M11.57 3.143a1 1 0 0 1 1.036.004l7.916 4.85A1 1 0 0 1 21 8.85v6.063a1 1 0 0 1-.485.858l-8.084 4.85a1 1 0 0 1-1.037-.005l-7.916-4.85A1 1 0 0 1 3 14.913V8.85a1 1 0 0 1 .486-.857l8.083-4.85zM5 10.636l5.916 3.625v3.717L5 14.353v-3.717zm7.916 7.361L19 14.347v-3.73l-6.084 3.65v3.73zm-.994-5.466l6.15-3.69-2.035-1.246-6.15 3.69 2.035 1.246zm-3.958-2.425l6.15-3.69-2.036-1.247-6.15 3.69 2.036 1.247z"
      clipRule="evenodd"
    />
  </SvgIcon>
)
